import React from 'react';

interface CabanaIconProps {
  className?: string;
}

const CabanaIcon: React.FC<CabanaIconProps> = ({ className = "w-6 h-6" }) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round"
      className={className}
    >
      {/* Roof/Canopy */}
      <path d="M2 9 L12 3 L22 9" />
      {/* Canopy sides */}
      <path d="M2 9 L2 11" />
      <path d="M22 9 L22 11" />
      {/* Fringe/decorative elements */}
      <path d="M4 11 L4 13" />
      <path d="M8 11 L8 13" />
      <path d="M12 11 L12 13" />
      <path d="M16 11 L16 13" />
      <path d="M20 11 L20 13" />
      {/* Posts */}
      <path d="M4 13 L4 20" />
      <path d="M20 13 L20 20" />
      {/* Base/platform */}
      <path d="M2 20 L22 20" />
    </svg>
  );
};

export default CabanaIcon;
